export const i18nCacheExpirationTime = 7 * 24 * 60 * 60 * 1000; // 7 days

const CONSTANTS = {
  i18nCacheExpirationTime: i18nCacheExpirationTime,
};

export default CONSTANTS;
